import * as Actions from '../actions';

const initialState = {
    courseList:  [],
    searchText:  '',
    majorList:   [],
    majorFilter: 'All',
    courseListLoaded: false
}

const enrollmentReducer = function (state = initialState, action) {
    switch (action.type) {
        case (Actions.GET_ENROLLMENT_COURSE_LIST):
        {
            let courseList = action.payload;
            
            courseList = courseList.map((course) => ({
                ...course,
                popoverAnchor: null
            }));

            return {
                ...state,
                courseList: courseList,
                courseListLoaded: true
            };
        }
        case (Actions.SET_SEARCH_TEXT):
        {
            const searchText = action.payload;
            
            return {
                ...state,
                searchText: searchText,
            };
        }
        case (Actions.GET_MAJOR_LIST):
        {
            const majorList = action.payload;

            return {
                ...state,
                majorList: majorList,
            };
        }
        case (Actions.SET_MAJOR_FILTER):
        {
            const majorFilter = action.payload;

            return {
                ...state,
                majorFilter: majorFilter
            }
        }
        case (Actions.SET_POPOVER_ANCHOR):
        {
            const { company_calendar_course_id, anchor } = action.payload;

            return {
                ...state,
                courseList: state.courseList.map((course) => {
                    if(course.company_calendar_course_id === company_calendar_course_id) {
                        return {
                            ...course,
                            popoverAnchor: anchor
                        }
                    } else {
                        return course;
                    }
                })
            }
        }
        case (Actions.SUBMIT_STUDENT_ENROLLMENT):
        {
            const { company_calendar_course_id, company_course_student_rel_id } = action.payload;

            return {
                ...state,
                courseList: state.courseList.map((course) => {
                    if(company_calendar_course_id === course.company_calendar_course_id) {
                        return {
                            ...course,
                            EnrollmentStatus: true,
                            company_course_student_rel_id: company_course_student_rel_id,
                        };
                    } else {
                        return course;
                    }
                })
            }
        }

        case (Actions.REMOVE_STUDENT_ENROLLMENT):
        {
            const { company_calendar_course_id } = action.payload;

            return {
                ...state,
                courseList: state.courseList.map((course) => {
                    if(company_calendar_course_id === course.company_calendar_course_id) {
                        return {
                            ...course,
                            EnrollmentStatus: false,
                            company_course_student_rel_id: 0,
                        };
                    } else {
                        return course;
                    }
                })
            }
        }

        default:
        {
            return state;
        }
    }
}

export default enrollmentReducer;


// WEBPACK FOOTER //
// src/main/content/enrollment/store/reducers/enrollment.reducer.js